import { useNotifications } from '@sparklayer-io/dashboard/store/notifications';
import type { NotificationHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/notification';

const { notify, dismiss } = useNotifications.getState();

export const notificationHandler: NotificationHandlerContract = { notify, dismiss };
